import React from "react";
import {
  FormGroup,
  FormGroupVerticalInput,
  Label,
  SearchGroups,
  SearchTabs,
  SearchDateTime,
} from "..";
import { getInputErrorMessage, hasErrorInput, SelectUtils } from "../../utils";
import Select2 from "../Select2";
import { Tabs } from "flowbite-react";
import tenkenTheme from "../../configs/themes/tenkenTheme";

const SearchPanelInspectionHistory = ({
  groupSettings,
  errors,
  dataSearch,
  setDataSearch,
  inputOptions,
  machineOptions,
  templateOptions,
  pageLoaded,
  supportValues,
  setSupportValues,
  handleSelectChange,
  frequencyOptions,
}) => {
  return (
    <>
      {pageLoaded && (
        <>
          <SearchDateTime
            dataSearch={dataSearch}
            setDataSearch={setDataSearch}
            supportValues={supportValues}
            setSupportValues={setSupportValues}
            errors={errors}
          />
          <SearchGroups
            groupSettings={groupSettings}
            errors={errors}
            inputOptions={inputOptions}
            dataSearch={dataSearch}
            handleSelectChange={handleSelectChange}
          />
          <FormGroup direction="horizontal">
            <Label
              text={groupSettings["machine"]?.name}
              className="lg:min-w-[248px] min-w-[232px]"
            />
            <FormGroupVerticalInput>
              <Tabs
                style="underline"
                theme={tenkenTheme.search_tabs}
                onActiveTabChange={(tab) =>
                  setSupportValues({ ...supportValues, machine_tab: tab })
                }
              >
                <Tabs.Item
                  title="テキスト入力"
                  active={supportValues.machine_tab === 0}
                >
                  <SearchTabs
                    name="machine_name"
                    groupSettings={groupSettings}
                    errors={errors}
                    dataSearch={dataSearch}
                    setDataSearch={setDataSearch}
                    machineOptions={machineOptions}
                  />
                </Tabs.Item>
                <Tabs.Item
                  title="プルダウン選択"
                  active={supportValues.machine_tab === 1}
                >
                  <SearchTabs
                    name="machine_id"
                    groupSettings={groupSettings}
                    errors={errors}
                    dataSearch={dataSearch}
                    setDataSearch={setDataSearch}
                    machineOptions={machineOptions}
                  />
                </Tabs.Item>
              </Tabs>
            </FormGroupVerticalInput>
          </FormGroup>
          <FormGroup direction="horizontal">
            <Label
              text="点検テンプレート"
              className="lg:min-w-[248px] min-w-[232px]"
            />
            <FormGroupVerticalInput
              error={getInputErrorMessage(errors, "template_id")}
            >
              <Select2
                options={templateOptions}
                value={SelectUtils.getSelectedValueFilter(
                  templateOptions,
                  dataSearch.template_id,
                  true
                )}
                hasError={hasErrorInput(errors, "template_id")}
                classNamePrefix="react-select"
                classSelect="machine-update__form--select"
                className="xl:w-[280px] w-[260px]"
                onChange={(e) =>
                  setDataSearch({ ...dataSearch, template_id: e.value })
                }
              />
            </FormGroupVerticalInput>
          </FormGroup>
          <FormGroup direction="horizontal">
            <Label
              text="点検回数"
              className="lg:min-w-[248px] min-w-[232px]"
            />
            <FormGroupVerticalInput
              error={getInputErrorMessage(errors, "inspection_number")}
            >
              <Select2
                options={frequencyOptions}
                value={SelectUtils.getSelectedValueFilter(
                  frequencyOptions,
                  dataSearch.inspection_number,
                  true
                )}
                hasError={hasErrorInput(errors, "inspection_number")}
                classNamePrefix="react-select"
                classSelect="machine-update__form--select"
                className="w-[100px]"
                onChange={(e) =>
                  setDataSearch({ ...dataSearch, inspection_number: e.value })
                }
              />
            </FormGroupVerticalInput>
          </FormGroup>
        </>
      )}
    </>
  );
};

export default SearchPanelInspectionHistory;
